import React from "react";
import "./CashCard.css";

const CashCard = () => {
  return (
    <div className="main-content">
      <div className="breadcrumb">
        Home / <span>View All</span>
      </div>
      <h2>Cash Card List</h2>

      <div className="page-header">
        <div>
          <h2>View all cash card</h2>
        </div>
        <div className="header-buttons">
          <button className="btn blue">+ Create New</button>
        </div>
      </div>

      <div className="card">
        <div className="top-controls">
          <div className="entries">
            Show{" "}
            <select>
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
            </select>{" "}
            entries
          </div>
          <div className="search-box">
            Search: <input type="text" />
          </div>
        </div>

        <div className="buttons">
          <button>Copy</button>
          <button>CSV</button>
          <button>Excel</button>
          <button>PDF</button>
          <button>Print</button>
          <button className="dropdown">Column visibility ▾</button>
        </div>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Code</th>
                <th>Amount</th>
                <th>Use Limit</th>
                <th>Usage Status</th>
                <th>Active/Inactive</th>
                <th>Expiry</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="11" className="empty">
                  No data available in table
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="table-footer">
          <p>Showing 0 to 0 of 0 entries</p>
          <div>
            <button disabled>Previous</button>
            <button disabled>Next</button>
          </div>
        </div>
      </div>

      <footer className="page-footer">
        <p>
          Copyright © 2025 <span className="brand">Ample Markets</span>. All
          rights reserved. <span className="version">Version 2.0</span>
        </p>
      </footer>
    </div>
  );
};

export default CashCard;
